import type { App } from 'vue';
import Auth from '@/plugins/auth.ts';
import { setAuthProvider } from '@/plugins/caching.ts';

const authService = new Auth();

// Wire auth into caching so it can validate cache entries by JWT sub
setAuthProvider(authService);

const VueAuth = {
    install(app: App) {
        app.config.globalProperties.$auth = authService;
        app.provide('$auth', authService);
    },
};

export { authService };
export default VueAuth;
